import { createStrings } from '@utils/local';

export const warehouseStrings = createStrings({
  ja: {
    city: '都市',
    name: '倉庫名',
    englishName: '英字名',
    zipcode: '郵便番号',
    address1: '住所1',
    address2: '住所2',
    principalName: '担当者名',
    phone: '電話番号',
    memo: 'メモ',
    shanghai: '上海',
    dongguan: '東莞',
    guangzhou: '広州',
    shenzhen: '深圳',
    xiamen: '廈門',
    qindao: '青島',
    dalian: '大連',
    tianjing: '天津',
  },
});

export const warehouseColors = {
  pink: '#F3A8FF',
  blue: '#5177FF',
  green: '#7DEB9C',
  red: '#FF7373',
  brown: '#926363',
  yellow: '#FFCF86',
};

export const warehouseColorNames = Object.keys(warehouseColors);
